const nf = new Intl.NumberFormat('en-US');

export const n = (v: number) => nf.format(v);

const usdFmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

/** A price in donation points as US dollars at the site's rate (`pointsPerUsd` from the config): 400 at 55 -> "$7.27". */
export const usdOf = (points: number, pointsPerUsd: number) => usdFmt.format(pointsPerUsd > 0 ? points / pointsPerUsd : 0);

/** "1 member", "12 members": the count, formatted, with the right noun. */
export const count = (v: number, one: string, many = `${one}s`) => `${nf.format(v)} ${v === 1 ? one : many}`;

export function compact(v: number): string {
  if (v >= 1e9) return `${(v / 1e9).toFixed(v >= 1e10 ? 0 : 1)}B`;
  if (v >= 1e6) return `${(v / 1e6).toFixed(v >= 1e7 ? 0 : 1)}M`;
  if (v >= 1e4) return `${Math.round(v / 1e3)}K`;
  return nf.format(v);
}

export function bytes(b: number): string {
  if (b >= 1024 ** 3) return `${(b / 1024 ** 3).toFixed(1)} GB`;
  if (b >= 1024 ** 2) return `${Math.round(b / 1024 ** 2)} MB`;
  return `${Math.round(b / 1024)} KB`;
}

const dateFmt = new Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
const dateTimeFmt = new Intl.DateTimeFormat(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
const timeFmt = new Intl.DateTimeFormat(undefined, { weekday: 'short', hour: 'numeric', minute: '2-digit' });

export const date = (iso: string | number | Date) => dateFmt.format(new Date(iso));
export const dateTime = (iso: string | number | Date) => dateTimeFmt.format(new Date(iso));
export const weekdayTime = (iso: string | number | Date) => timeFmt.format(new Date(iso));

export function ago(iso: string | number | Date, now = Date.now()): string {
  const s = Math.round((now - new Date(iso).getTime()) / 1000);
  if (s < 60) return 'just now';
  if (s < 3600) return `${Math.floor(s / 60)} min ago`;
  if (s < 86400) return `${Math.floor(s / 3600)} h ago`;
  if (s < 86400 * 30) return `${Math.floor(s / 86400)} d ago`;
  return date(iso);
}

/** 3725 -> "1 h 2 min"; for countdowns use `clock`. */
export function duration(seconds: number): string {
  const s = Math.max(0, Math.round(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h && m) return `${h} h ${m} min`;
  if (h) return `${h} h`;
  return `${m} min`;
}

/** Countdown text: "2d 04:10:05", "04:10:05", "10:05". */
export function clock(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const d = Math.floor(total / 86400);
  const h = Math.floor((total % 86400) / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (x: number) => String(x).padStart(2, '0');
  if (d) return `${d}d ${pad(h)}:${pad(m)}:${pad(s)}`;
  if (h) return `${pad(h)}:${pad(m)}:${pad(s)}`;
  return `${pad(m)}:${pad(s)}`;
}

/** rAthena map ids to something readable: prt_fild08 -> Prt Fild08 (real names come from gamedata). */
export function mapLabel(map: string): string {
  return map.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
